import React from 'react';
import { ArrowRight, Settings, Award, Users, ShieldCheck } from 'lucide-react';
import { companyInfo } from '../mock';

export const Hero = () => {
  const scrollToQuote = () => {
    const element = document.querySelector('#quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
  { icon: Settings, text: "Customization" },
  { icon: Award, text: "Durability" },
  { icon: Users, text: "Reliability" }];


  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZ3xlbnwwfHx8fDE3NzQwMjgzMzJ8MA&ixlib=rb-4.1.0&q=85')`
        }}>

        <div className="absolute inset-0 bg-slate-900/85"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
        <div className="text-center">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {companyInfo.tagline}
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto"> OEM of tailor-made vulcanizing machines and accessories for industrial excellence

          </p>

          {/* Feature Pills */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">

                  <Icon size={20} className="text-blue-400" />
                  <span className="text-white font-medium">{feature.text}</span>
                </div>);

            })}
          </div>

          {/* CTA Button */}
          <button
            onClick={scrollToQuote}
            className="group inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105">

            Get a Quote
            <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/50 rounded-full mt-2"></div>
        </div>
      </div>

      {/* Badges - Bottom Right */}
      <div className="absolute bottom-8 right-8 z-20 flex items-center gap-3">
        <button
          onClick={() => {
            const el = document.querySelector('#certification');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          data-testid="hero-iso-badge"
          className="group flex items-center gap-2.5 bg-slate-900/70 backdrop-blur-sm border border-blue-500/40 px-4 py-2.5 rounded-md hover:border-blue-400 hover:bg-slate-900/85 transition-all duration-300"
          aria-label="View ISO 9001:2015 certification">

          <ShieldCheck size={26} className="text-orange-500 group-hover:scale-110 transition-transform duration-300" />
          <span className="text-left leading-tight">
            <span className="block text-white font-bold text-xs md:text-sm">ISO 9001:2015</span>
            <span className="block text-blue-300 text-[10px] md:text-xs font-medium tracking-wide">CERTIFIED</span>
          </span>
        </button>
        <div className="bg-slate-900/70 backdrop-blur-sm p-2 rounded-md">
          <img 
            src="https://customer-assets.emergentagent.com/job_precision-machines-4/artifacts/ydc2g12i_msme-logo-png_seeklogo-480293.jpeg"
            alt="MSME Registered"
            className="w-20 md:w-24 lg:w-28 h-auto rounded-md hover:scale-110 transition-transform duration-300 opacity-95"
          />
        </div>
      </div>
    </section>);

};